import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import SecurityService from '../../service/SecurityService';
import { Button } from 'primereact/button';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import DOMPurify from 'dompurify';
import CompetitionJobDutyEditDialog from './CompetitionJobDutyEditDialog';

const CompetitionJobDutyComponent = (props) => {
    const [competition, setCompetition] = useState(null);
    const [hasEditPermission, setHasEditPermission] = useState(false);
    const [editDialogVisible, setEditDialogVisible] = useState(false);

    const toast = useRef(null);

    useEffect(() => {
        const checkEditPermission = async () => {
            setHasEditPermission(await SecurityService.check('CAN_EDIT_JOB_COMPETITION', props?.competition?.id));
        };

        const getCompetition = async () => {
            // console.log(props?.competition);
            setCompetition(props?.competition);
        };

        getCompetition();
        checkEditPermission();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    const showEditDialog = () => {
        setEditDialogVisible(true);
    };

    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
            node.setAttribute('rel', 'noopener');
        }
    });

    const afterSave = (savedCompetition, success, error) => {
        if (success) {
            setCompetition(savedCompetition)
            if (typeof props.afterSave === 'function') {
                props.afterSave(savedCompetition);
            }
            toast?.current?.show({ severity: 'success', summary: translatedMessage('generic.save.success') });
        } else {
            toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <div className='col-12 flex flex-row align-items-center mt-5'>
                <h5 className='mb-0'>{translatedMessage('job.jobDuty')}</h5>
                <div>
                    <Button
                        label={translatedMessage('generic.edit')}
                        icon="pi pi-pencil"
                        className="pcn-button-slim-with-icon p-button-primary ml-3"
                        onClick={showEditDialog}
                        visible={hasEditPermission && !props.readOnly}
                        disabled={!CompetitionUtils.canEdit(competition)}
                    />
                </div>
            </div>
            <div className='col-12'>
                <div className='w-full p-2 pcn-panel-border'>
                    {competition?.jobDuty && <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(competition?.jobDuty) }} />}
                    {!competition?.jobDuty && "-"}
                </div>
            </div>

            {editDialogVisible &&
                <CompetitionJobDutyEditDialog
                    value={competition}
                    visible={editDialogVisible}
                    afterSave={afterSave}
                    visibleSetter={() => setEditDialogVisible(false)}
                />
            }
        </>
    );
};

export default CompetitionJobDutyComponent;
